define('casino/populate',['jquery', 'all/navigation', 'casino/casino', 'casino/casino-data', 'all/template', 'casino/populate'], function ($, navigation, casino, casinoData) {
	'use strict';

	var placeholder = navigation.staticURL('img/tmp-game-icon.png');

	$.fn.populate = function (gameIds, options) {

		var defaults = {
			gamesPerPage: 0,
			onlyIcon: false
		};

		options = $.extend(defaults, options);

		if (!$.isArray(gameIds)) {
			gameIds = [gameIds];
		}

		this.each(function () {

			var $this = $(this);

			var id = $this.attr('id') || $this.parents('[id]').first().attr('id') || 'unknown element';

			var $grid = $this.find('.cnt-game-image .grid template:first').parent();
			if ($grid.length === 0 && $this.is('.grid')) {
				$grid = $this;
			}

			if (!gameIds) {
				console.error('gameIds undefined for:', id);
				return;
			}

			if (gameIds.length === 0) {
				$grid.contents().each(function () {
					var $content = $(this);
					if (!$content.is('template')) {
						$content.remove();
					}
				});
				return;
			}

			var processedGames = [];
			for (var i = 0; i < gameIds.length; i++) {
				var gameId = gameIds[i];

				if (!/^(?:game|group)=/.test(gameId)) {
					gameId = 'game=' + gameId;
				}

				var game = casino.getMatchingGame(gameId);
				if (game === undefined) {
					console.error('No game for id: ' + gameId);
					continue;
				}
				var tourneyGames;
				if (typeof casinoData.gamesInTournaments[gameId] === 'undefined') {
					tourneyGames = 0;
				}
				else {
					tourneyGames = casinoData.gamesInTournaments[gameId].length;
				}
				var icon = (game.icon) ? navigation.dynamicURL(game.icon) : placeholder;

				processedGames.push($.extend({}, game, {
					id: gameId,
					name: game.name || '&nbsp;',
					description: game.shortDescription || '&nbsp;',
					isNew: game.isNew && !game.isHot,
					icon: icon,
					href: '#!' + gameId,
					hasTournament: tourneyGames,
					isAvailableOnMobile: game.isAvailableOnMobile,
					showText: !options.onlyIcon
				}));
			}

			function registerClickHandlers($target) {
				$target.find('section').on('click', function () {
					window.location.hash = '#!' + $(this).data('game');
				});
			}

			function populatePage($grid, games, $template) {
				$grid.data('populate', null);
				if ($template) {
					$template.applyTemplate(games, {into: $grid});
				} else {
					$grid.applyTemplate(games);
				}
				registerClickHandlers($grid);
			}

			function populatePageLater($grid, games, $template, $parent) {
				$grid.data('populate', function () {
					var $visiblePage = $parent.children(':not(template)').first();
					$grid.css({
						height: $visiblePage.height()
					});
					populatePage($grid, games, $template);
				});
			}

			if (options.gamesPerPage === 0) {
				populatePage($grid, processedGames);
			} else {
				var sectionCount = Math.ceil(processedGames.length / options.gamesPerPage);
				$grid.siblings().remove();
				var $clone = $grid.clone();
				populatePage($grid, processedGames.slice(0, options.gamesPerPage));
				var $template = $clone.find('template');
				$clone.empty();
				var $parent = $grid.parent();
				for (var j = 1; j < sectionCount; j++) {
					//console.time(id + '-page-' + j);
					var $page = $clone.clone();
					$parent.append($page);
					populatePageLater($page, processedGames.slice(options.gamesPerPage * j, options.gamesPerPage * (j + 1)), $template, $parent);
					//console.timeEnd(id + '-page-' + j);
				}
			}
		});
		return this;
	};
});

